function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBasicSubscription = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 250 250",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M123.7 65 65 124.24 125.52 185 185 125.72z",
  style: {
    fill: "#d8e3fd"
  }
}));
export { SvgBasicSubscription as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTAgMjUwIj48ZGVmcz4KPHN0eWxlPi5kaWFtb25kLTF7ZmlsbDojZDhlM2ZkO308L3N0eWxlPgo8L2RlZnM+PHBvbHlnb24gY2xhc3M9ImRpYW1vbmQtMSIgcG9pbnRzPSIxMjMuNyA2NSA2NSAxMjQuMjQgMTI1LjUyIDE4NSAxODUgMTI1LjcyIDEyMy43IDY1Ii8+PC9zdmc+";